import { Container, Row, Col, Accordion } from 'react-bootstrap';
import PageHeader from '@/website/components/PageHeader.tsx';

const faqs = [
  {
    question: 'Do you accept insurance?',
    answer:
      'Yes, we currently accept Aetna, Blue Cross Blue Shield, United Health Care, Cigna, Regence, and Premera. We will consider credentialing with more companies to better serve our clients, so please reach out if we do not currently accept your insurance. We ask all clients to verify insurance coverage with their insurance company before scheduling an appointment.',
  },
  {
    question: 'Will my appointment be 100% covered?',
    answer:
      'Clients are responsible for understanding the details of their coverage and paying for non-covered services and fees. If your insurance plan does not cover a session, you are responsible for paying the full self-pay rate. To be mindful of our time, all questions requiring more than 10 minutes to answer will need to be addressed in a scheduled follow-up visit. This is due to insurance not covering services unless it is a traditional appointment. We appreciate your understanding.',
  },
  {
    question: 'What happens if you do not accept my insurance?',
    answer:
      'For clients who have out-of-network insurance or choose the self-pay option, payment is required at the time of service. We offer superbills for clients who have out-of-network insurance. Clients can submit a claim with their insurance for reimbursement services provided—this will depend on your insurance coverage. After the appointment, you will receive a Superbill receipt that you will submit to your insurance company.',
  },
  {
    question: 'Which forms of payment are accepted?',
    answer:
      'Credit Card (Visa, MasterCard, American Express, Discover), Debit Card, FSA/HSA',
  },
  {
    question: 'Do you have a cancellation policy?',
    answer:
      'Yes, we have chosen to implement a cancellation policy. For any no-show appointments or appointments canceled within 24 hours of the scheduled appointment time, the cancelation fee is $40. We appreciate your understanding.',
  },
  {
    question: 'Why is a credit card required when booking?',
    answer:
      'Your credit card is kept on file to secure your appointment. Your credit card will be charged to cover the cost of your session, additional non-covered services, or any late cancellation fees.',
  },
];

const FAQsPage = () => {
  const half = Math.ceil(faqs.length / 2);
  const firstHalf = faqs.slice(0, half);
  const secondHalf = faqs.slice(half);

  return (
    <>
      <PageHeader
        title="Frequently Asked Questions"
        imageSrc="/images/thinking-face.svg"
      />
      <section className="bg-white py-5">
        <Container>
          <Accordion flush>
            <Row>
              <Col md={6}>
                {firstHalf.map((faq, index) => (
                  <Accordion.Item eventKey={String(index)} key={index}>
                    <Accordion.Header className="fw-bold">
                      {faq.question}
                    </Accordion.Header>
                    <Accordion.Body>{faq.answer}</Accordion.Body>
                  </Accordion.Item>
                ))}
              </Col>
              <Col md={6}>
                {secondHalf.map((faq, index) => (
                  <Accordion.Item
                    eventKey={String(index + half)}
                    key={index + half}
                  >
                    <Accordion.Header className="fw-bold">
                      {faq.question}
                    </Accordion.Header>
                    <Accordion.Body>{faq.answer}</Accordion.Body>
                  </Accordion.Item>
                ))}
              </Col>
            </Row>
          </Accordion>
        </Container>
      </section>
    </>
  );
};

export default FAQsPage;
